import {
  BasePluginsExtension,
  BaseSchemaExtension,
  BlockquoteExtension,
  BoldExtension,
  CodeBlockExtension,
  CodeExtension,
  ColorExtension,
  EmojiExtension,
  Extension,
  FilestackExtension,
  FilestackExtensionService,
  FormattingToolbarExtension,
  HighlightExtension,
  HorizontalRuleExtension,
  ItalicExtension,
  ListExtension,
  MaxLengthExtension,
  MentionExtension,
  PlaceholderExtension,
  PlaceholderExtensionOptions,
  PopupExtension,
  SlashCommandsExtension,
  SmallParagraphExtension,
  StrikethroughExtension,
  TrailingParagraphExtension,
  UnderlineExtension,
  UrlExtension,
} from "@smartsuite/smartdoc";
import { MentionExtensionService } from "@smartsuite/smartdoc/lib/esm/extensions/mention/types";

import { MiniEditorExtension } from "./MiniEditorExtension";

const formChecklistMentionService: MentionExtensionService = {
  isCurrentMember: () => false,
  openDetails: () => undefined,
  openPublicProfile: () => undefined,
  searchMembers: () => [],
  searchTeams: () => [],
  searchRecords: () => [],
};

const formChecklistFilestackService: FilestackExtensionService = {
  getAttachmentUrl: (attrs) => attrs.url ?? "",
  getImageUrl: (attrs) => attrs.url ?? "",
  getVideoUrl: (attrs) => attrs.url ?? "",
  validateUploadingFile: () => false,
  uploadByUrl: () => Promise.reject(new Error("unavailable")),
  uploadFile: () => Promise.reject(new Error("unavailable")),
  openPicker: () => Promise.reject(new Error("unavailable")),
  openModalGallery: () => undefined,
};

export interface ChecklistEditorExtensionsOptions {
  placeholder: PlaceholderExtensionOptions;
  maxLength: number;
  filestackService?: FilestackExtensionService;
}

export const createChecklistEditorExtensions = ({
  placeholder,
  maxLength,
  filestackService,
}: ChecklistEditorExtensionsOptions): Extension[] => [
  new MiniEditorExtension(),
  new BaseSchemaExtension(),
  new CodeExtension(),
  new SmallParagraphExtension(),
  new BoldExtension(),
  new ItalicExtension(),
  new UnderlineExtension(),
  new StrikethroughExtension(),
  new ColorExtension(),
  new HighlightExtension(),
  new PlaceholderExtension(placeholder),
  new BlockquoteExtension(),
  new CodeBlockExtension(),
  new EmojiExtension(),
  new MentionExtension(formChecklistMentionService),
  new FilestackExtension(filestackService ?? formChecklistFilestackService),
  new HorizontalRuleExtension(),
  new UrlExtension(),
  new PopupExtension(),
  new MaxLengthExtension(maxLength),
  new TrailingParagraphExtension(),
  new ListExtension(),
  new SlashCommandsExtension(),
  new BasePluginsExtension(),
  new FormattingToolbarExtension({ mode: "floating" }),
];
